import { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import { requestPasswordReset } from '../../../services/authService';
import { authMethods } from '../../../config/authMethods';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('');
    setIsSubmitting(true);

    try {
      const response = await requestPasswordReset({ email });
      setStatus(response.message || 'If the email is registered, a reset link has been sent.');
    } catch (error) {
      setStatus(error.message || 'Unable to start password reset.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!authMethods.emailEnabled) {
    return <AuthLayout title="Forgot password" subtitle="No login methods are currently enabled."><div className="alert alert-warning py-2 mb-0">No login methods are currently enabled.</div></AuthLayout>;
  }

  return (
    <AuthLayout
      title="Forgot password"
      subtitle="Enter your email to receive secure password reset instructions."
    >
      <form onSubmit={handleSubmit} className="d-grid gap-3">
        <div>
          <label className="form-label" htmlFor="forgotEmail">
            Account email
          </label>
          <input
            id="forgotEmail"
            name="email"
            type="email"
            className="form-control"
            placeholder="you@example.com"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </div>

        {status && (
          <div className="alert alert-info py-2 mb-0" role="status">
            {status}
          </div>
        )}

        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
          {isSubmitting ? 'Sending reset link...' : 'Send reset link'}
        </button>

        <div className="text-center small">
          <Link to="/login">Return to sign in</Link>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
